import { useMemo, useRef, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { createApiClient } from '../services/apiInterceptor';
import { useTenant } from '../contexts/TenantContext';

export const useApi = () => {
  const { authState } = useOktaAuth();
  const { currentTenant } = useTenant();
  const apiRef = useRef(null);
  const prevAuthRef = useRef(authState?.isAuthenticated);
  const prevTenantRef = useRef(currentTenant?.tenantId);

  const api = useMemo(() => {
    const authChanged = prevAuthRef.current !== authState?.isAuthenticated;
    const tenantChanged = prevTenantRef.current !== currentTenant?.tenantId && 
                          currentTenant?.tenantId !== undefined;
    
    if (!apiRef.current || authChanged || tenantChanged) {
      apiRef.current = createApiClient(authState, currentTenant?.tenantId);
      prevAuthRef.current = authState?.isAuthenticated;
      prevTenantRef.current = currentTenant?.tenantId;
    }
    
    return apiRef.current;
  }, [authState, currentTenant?.tenantId]);

  return api;
};

export default useApi;





